<template>
	<span
		v-if="svgContent"
		v-html="svgContent"
		:style="svgStyle"
		:class="['svg-icon', className]"
		v-bind="attrs"
		@mouseenter="isHovered = true"
		@mouseleave="isHovered = false"
	/>
</template>

<script setup lang="ts">
import {
	defineProps,
	computed,
	ref,
	watch,
	useAttrs
} from 'vue'

type AppIconProps = {
	name: string,
	size?: string | number,
	width?: string | number,
	height?: string | number,
	color?: string,
	hoverColor?: string,
	cursor?: 'pointer' | string,
	className?: string
}

const props = withDefaults(defineProps<AppIconProps>(), {
	size: '14px',
	color: 'currentColor',
	className: ''
})

const attrs = useAttrs()
const svgContent = ref('')
const isHovered = ref(false)

const loadSvg = () => {
	try {
		const module = require(`!!raw-loader!@/assets/icons/${props.name}.svg`)
		svgContent.value = module.default || module
	} catch (error) {
		console.warn(`SVG icon "${props.name}" not found:`, error)
		svgContent.value = ''
	}
}

const svgStyle = computed(() => {
	const style = {
		display: 'inline-block',
		verticalAlign: 'middle',
		fill: props.color,
		color: props.color
	}

	if (props.width) {
		style.width = props.width
		style.minWidth = props.width
		style.height = props.height || props.width
	} else if (props.size) {
		style.width = props.size
		style.minWidth = props.size
		style.height = props.size
	}

	if (props.cursor) {
		style.cursor = props.cursor
	}

	if (props.hoverColor) {
		style.color = isHovered.value ? props.hoverColor : props.color
	}

	return style
})

watch(() => props.name,
	loadSvg,
	{ immediate: true }
)
</script>

<style scoped lang="scss">
.svg-icon {
	line-height: 0;
}

.svg-icon :deep(svg) {
	display: block;
	width: 100%;
	height: 100%;
	max-width: 100%;
	max-height: 100%;
}

</style>
